const state = () => ({
	user: {},
	company: [],
	profile: {},
	sidebar:[]
})

const getters = {
	getUser: state => state.user,
	getProfile: state => state.profile,
	isDoctor: state => state.profile && state.profile.user_roles && (state.profile.user_roles.includes('doctor') || state.profile.user_roles.includes('medical_officer')),
}

const mutations = {
    setUser: (state) => {
        state.user = JSON.parse(localStorage.getItem('user'))
    },
	setProfile: (state, payload) => {
		state.profile = payload
	},
	setCompany: (state, payload) => state.company = payload,
	setSidebar: (state, payload) => state.sidebar = payload,
}

export default {
	namespaced: true,
	state,
	getters,
	mutations
}